export var inmatePostalMail = function inmatePostalMail(centralApi) {
  return {
    index: function index(params) {
      if (params === void 0) {
        params = {};
      }
      return centralApi.get('/inmate-postal-mail', {
        params: params
      });
    },
    get: function get(id) {
      return centralApi.get("/inmate-postal-mail/".concat(id));
    },
    approve: function approve(id) {
      return centralApi.put("/inmate-postal-mail/".concat(id, "/approve"));
    },
    reject: function reject(id, rejectionReason) {
      return centralApi.put("/inmate-postal-mail/".concat(id, "/reject"), {
        note: rejectionReason
      });
    }
  };
};